<template>
  <div v-show="editShow">
    <div class="container">
      <el-row :gutter="20">
        <div class="clearfix">
          <div class="crumbs">
            <i class="el-icon-back"></i>
            <el-button type="text" @click="goBack">返回</el-button>
          </div>
          <div class="btn-save">
            <el-button type="primary" @click="saveClick('ruleForm')"
            >保存
            </el-button
            >
          </div>
        </div>
        <div class="form-box">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="eidt-el-form"
          >
            <el-form-item label="名称" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="码值" prop="code">
              <el-input v-model="ruleForm.code"></el-input>
            </el-form-item>
            <el-form-item label="公司" prop="company">
              <el-input v-model="ruleForm.company"></el-input>
            </el-form-item>
            <el-form-item label="职务" prop="position">
              <el-input v-model="ruleForm.position"></el-input>
            </el-form-item>
            <el-form-item label="证件类型" prop="documentTypeId">
              <el-select
                  v-model="ruleForm.documentTypeId"
                  placeholder="选择证件类型"
              >
                <el-option
                    v-for="(type, index) in DocumentType"
                    :label="type.name"
                    :value="type.documentTypeId"
                >
                  <div @click="getChangeDocuType(type)">{{ type.name }}</div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="票类型" prop="ticketTypeId">
              <el-select
                  v-model="ruleForm.ticketTypeId"
                  placeholder="选择票类型"
              >
                <el-option
                    v-for="(type, index) in TicketType"
                    :label="type.name"
                    :value="type.ticketTypeId"
                >
                  <div @click="getChangeType(type)">{{ type.name }}</div>
                </el-option>
              </el-select>
            </el-form-item>
            <UploadImg
                @uploadImg="getUploadImg"
                :editImg="editImg"
                :imgTitle="imgTitle"
            ></UploadImg>
            <el-form-item label="备注" prop="remark">
              <el-input
                  v-model="ruleForm.remark"
                  type="textarea"
                  :rows="2"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import UploadImg from "../../public/UploadImg";
import bus from "../../common/bus";

export default {
  name: "editprojectmanage",
  data() {
    return {
      rules: {
        name: [{required: true, message: "名称不能为空", trigger: "blur"}],
        code: [{required: true, message: "码值不能为空", trigger: "blur"}],
        documentTypeId: [
          {required: false, message: "请选择证件类型", trigger: "blur"},
        ],
        ticketTypeId: [
          {required: false, message: "请选择票类型", trigger: "blur"},
        ],
      },
      projectId: localStorage.getItem("project_Id"),
      ruleForm: {
        name: "",
        documentTypeId: "",
        ticketTypeId: "",
        code: "",
        url: "",
        position: "",
        company: "",
        remark: "",
        projectId: localStorage.getItem("project_Id"),
      },
      editImg: "",
      projectAvatarId: "",
      dataList: [],
      documentTypeId: "",
      ticketTypeId: "",
      DocumentType: [],
      TicketType: [],
      imgTitle: "上传头像",
    };
  },
  props: {
    editShow: {
      type: Boolean,
      default: false,
    },
    editData: {
      type: Object,
    },
  },
  created() {
    var project_Id = localStorage.getItem("project_Id");
    this.projectId = project_Id;

    this.getDocumentType();
    this.getTicketType();
  },
  watch: {
    editData: function () {
      const item = this.editData;
      if (item) {
        this.ruleForm = {
          name: item.name,
          company: item.company,
          position: item.position,
          code: item.code,
          documentTypeId: item.documentTypeId,
          ticketTypeId: item.ticketTypeId,
          remark: item.remark,
          documentId: item.documentId,
          ticketId: item.ticketId,
          url: item.url,
        };
        this.projectAvatarId = item.projectAvatarId;
        this.editImg = item.url;
      }
    },
  },
  methods: {
    saveClick(ruleForm) {
      this.ruleForm = {
        company: this.ruleForm.company,
        position: this.ruleForm.position,
        name: this.ruleForm.name,
        code: this.ruleForm.code,
        remark: this.ruleForm.remark,
        projectId: this.projectId,
        url: this.ruleForm.url,
        documentTypeId: this.ruleForm.documentTypeId,
        ticketTypeId: this.ruleForm.ticketTypeId,
      };
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (!this.projectAvatarId) {
            this.$axios.post("/ProjectAvatar/", this.ruleForm).then((res) => {
              if (res.data.hasError == false) {
                this.$message.success("保存成功！");
                this.goBack();
                this.$refs[ruleForm].resetFields();
              } else {

                this.$message.error(res.data.message);
              }
            });
          } else {
            this.$axios
                .put("/ProjectAvatar/" + this.projectAvatarId + "", this.ruleForm)
                .then((res) => {
                  if (res.data.hasError == false) {
                    this.$message.success("编辑成功！");
                    this.goBack();
                    this.$refs[ruleForm].resetFields();
                  } else {

                    this.$message.error(res.data.message);
                  }
                });
          }
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.editImg = null;
      this.editData = null;
      this.$emit("backFunStu");
      this.projectAvatarId = "";
    },
    getUploadImg(imgSrc) {
      this.ruleForm.url = imgSrc;
    },
    getTicketType() {
      this.$axios.get("/TicketType/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.TicketType = [...res.data.data];
        }
      });
    },
    getDocumentType() {
      this.$axios.get("/DocumentType/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.DocumentType = [...res.data.data];
        }
      });
    },
    getChangeType(type) {
      this.ruleForm.ticketTypeId = type.ticketTypeId;
    },
    getChangeDocuType(type) {
      this.ruleForm.documentTypeId = type.documentTypeId;
    },
  },
  components: {
    UploadImg,
  },
};
</script>